import React from "react";

const points = [
  "High fiber with plant protein",
  "Optimal carbohydrate blend",
  "Dual protein blend",
  "No Artificial sweetener",
];

const HomeGreenScroll = () => {
  return (
    <div className="scrolling-text ">
      <div className="scroll-content font-xlg poppins-text">
        {points.map((point, index) => (
          <span key={index}>{point}</span>
        ))}
        {points.map((point, index) => (
          <span key={`duplicate-${index}`}>{point}</span>
        ))}
      </div>
    </div>
  );
};

export default HomeGreenScroll;
